import { render } from "./DashboardHeader.vue?vue&type=template&id=33ecea60&scoped=true"
import script from "./DashboardHeader.vue?vue&type=script&lang=js"
export * from "./DashboardHeader.vue?vue&type=script&lang=js"

import "./DashboardHeader.vue?vue&type=style&index=0&id=33ecea60&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-33ecea60"

export default script